import { PageLocatorMap } from '../types/PageLocatorMap';

export const verificationUploadPage = {
  alert: {
    fileError: 'verification-upload-page.form.alert.file-error',
    uploadError: 'verification-upload-page.form.alert.upload-error',
  },
  footer: {
    root: 'verification-upload-page.footer.root',
  },
  form: {
    cancelButton: 'verification-upload-page.form.cancel-button',
    getUploadItem: (index: number): string =>
      `verification-upload-page.form.upload-item-${index + 1}`,
    h1: 'verification-upload-page.form.h1',
    h2: 'verification-upload-page.form.h2',
    root: 'verification-upload-page.form.root',
    submitButton: 'verification-upload-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
